import { curry1 } from './curry1';
import { curry2 } from './curry2';
export function curry3(fn) {
    function curried(a, b, c) {
        switch (arguments.length) {
            case 0: return curried;
            case 1: return curry2(function (b, c) { return fn(a, b, c); });
            case 2: return curry1(function (c) { return fn(a, b, c); });
            default: return fn(a, b, c);
        }
    }
    return curried;
}
//# sourceMappingURL=curry3.js.map